import React from 'react';
import PropTypes from 'prop-types';
//import Tooltip from 'jsx/elements/messages/Tooltip';


//import Amount from "components/Display/Amount";




const PaymentOrderTag = ({ payments, boxType}) => {

  // toolTipContent = (item) => {
  //   return (
  //     <table>
  //       <tr>
  //         <td>Innborgun númer:</td>
  //         <td>{item.transactionNumber}</td>
  //       </tr>
  //       <tr>
  //         <td>Úthlutunar röð:</td>
  //         <td>{item.paymentOrder.toString()}</td>
  //       </tr>
  //       <tr>
  //         <td>Upphæð innb.:</td>
  //         <td><Amount data={item.fromAmount} /></td>
  //       </tr>
  //       <tr>
  //         <td>Færslulykill:</td>
  //         <td>{item.transactionKey} {item.name}</td>
  //       </tr>
  //       <tr>
  //         <td>Úthlutað:</td>
  //         <td><Amount data={item.amount} /></td>
  //       </tr>
  //     </table>);
  // };


  return (
    <div>
    {payments.map((item, i)=>{
      let backgroundStyle = {
        background : item.tagDetail.color
      };
      return(
        <div className="calc-tag" key={i}>
          <span tabIndex={item.paymentOrder} className={boxType === 'circle' ? 'calc-payment-fts-tag' : 'calc-payment-tag '} style={backgroundStyle}> {item.tagDetail.text} </span>
        </div>
      );
    })}
    </div>
  );



};

PaymentOrderTag.propTypes = {
  payments: PropTypes.array,
  boxType: PropTypes.string,
};

export default PaymentOrderTag;




// WEBPACK FOOTER //
// ./src/pages/Calculation/ResultsDetail/PaymentOrderTag.js